<template>
  <div class="mp-container flex-column">
    <div class="mb-3">
      <input type="text" v-model="query" class="form-control" v-on:keyup.enter="search" />
    </div>
    <div class="mb-3" v-if="resultCount > 0">
      {{resultCount}} {{ translations.searchResults }}
    </div>
    <ul class="list-group d-block d-md-none mp-panel-scroll">
      <md-paper-page-search-item v-for="result in results" @page-selected="openPage" :is-mobile="false" :result="result"></md-paper-page-search-item>
    </ul>
    <ul class="list-group d-none d-md-block mp-panel-scroll">
      <md-paper-page-search-item v-for="result in results" @page-selected="openPage" :is-mobile="true" :result="result"></md-paper-page-search-item>
    </ul>
    <div class="mp-paging mt-3">
      <md-paper-pager :page="page" :max-page="maxPage" v-on:paging="changePaging"></md-paper-pager>
    </div>
  </div>
</template>

<script>
import {getParameterByName, showError} from "../helpers";
import MdPaperPager from "./Pager.vue";
import MdPaperPageSearchItem from "./PageSearchItem.vue";
import axios from 'axios';

export default {
  emits: ["pageSelected"],
  components: {MdPaperPageSearchItem, MdPaperPager},
  data() {
    return {
      query: "",
      resultCount: 0,
      offset: 0,
      limit: 25,
      results: []
    }
  },
  computed: {
    recordId() {
      return this.$store.state.recordId
    },
    translations() {
      return multiPaper.translations;
    },
    showNoResults() {
      var self = this;
      return self.resultCount === 0 && query !== "";
    },
    page() {
      var self = this;
      return Math.ceil((self.offset + 1) / self.limit);
    },
    maxPage() {
      var self = this;
      return Math.ceil(self.resultCount / self.limit);
    }
  },
  methods: {
    search: function () {
      var self = this;
      if (self.query !== "") {
        axios.get("/umbraco/mdpaper/page/SearchFromRecord?recordId=" + self.$store.state.recordId + "&query=" + self.query + "&offset=" + self.offset + "&limit=" + self.limit).then(function (response) {
          self.resultCount = response.data.total;
          self.results = response.data.data;
        }).catch(showError);
      }
    },
    changePaging: function (number) {
      var self = this;
      self.offset = (number - 1) * self.limit;
      self.search();
    },
    openPage: function (event) {
      var self = this;
      self.$emit("pageSelected", event);
    }
  },
  beforeMount: function () {
    var self = this;
    var queryParam = getParameterByName("q")
    if (self.query !== "" && queryParam !== null) {
      self.query = queryParam;
    }
  }
}
</script>